import { SetStateAction, useCallback } from 'react';
import { useFormContext } from '@grnhse/seedling/lib/birch/components/forms/form';
import type { Item } from '@grnhse/seedling/lib/birch/components/forms/dropdown';
import type { SavedFiltersProps } from 'talent_matching/components/filters/saved_filters';
import type { GreenhouseFilterPreset } from 'talent_matching/talent_rediscovery/types';

type UseSavedFiltersConfig = {
  featureType: string;
  formDefaults: Record<string, unknown>;
  savedFilterSet: Item | null;
  setSavedFilterSet: (item: Item | null) => void;
  savedSearchOptions: Item[];
  setSavedSearchOptions: (options: SetStateAction<Item[]>) => void;
  parseSavedSearch: (response: unknown) => Record<string, unknown>;
  buildQueryString: () => string;
  greenhouseFilterPresets?: GreenhouseFilterPreset[];
};

type UseSavedFiltersReturn = {
  savedFiltersProps: SavedFiltersProps;
  handleClearAll: () => void;
};

export function useSavedFilters(
  config: UseSavedFiltersConfig
): UseSavedFiltersReturn {
  const { reset } = useFormContext();
  const {
    featureType,
    formDefaults,
    savedFilterSet,
    setSavedFilterSet,
    savedSearchOptions,
    setSavedSearchOptions,
    parseSavedSearch,
    buildQueryString,
    greenhouseFilterPresets,
  } = config;

  const handleClearAll = useCallback(() => {
    setSavedFilterSet(null);
    reset(formDefaults);
  }, [setSavedFilterSet, reset, formDefaults]);

  return {
    savedFiltersProps: {
      featureType,
      savedFilterSet,
      setSavedFilterSet,
      setSavedSearchOptions,
      formDefaults,
      savedSearchOptions,
      parseSavedSearch,
      buildQueryString,
      greenhouseFilterPresets,
    },
    handleClearAll,
  };
}
